import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { _HttpClient, SettingsService } from '@delon/theme';
import {
  NzSelectComponent,
  NzSelectModeType,
  NzSelectModule
} from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ViewItemComponent } from 'src/app/shared/components/view-item/view-item.component';

import { SelectBaseComponent } from '../../select-base';

@Component({
  selector: 'app-cac-select',
  templateUrl: './cac-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    NzSelectModule,
    NzSpinModule,
    NzDividerModule,
    FormsModule,
    ReactiveFormsModule,
    ViewItemComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BankCashAccountSelectComponent),
      multi: true
    }
  ]
})
export class BankCashAccountSelectComponent
  extends SelectBaseComponent
  implements OnDestroy, AfterViewInit, OnInit
{
  @Input() labelType: 'code' | 'name' | 'full' = 'full';
  @Input() mode: NzSelectModeType = 'default';
  @Input() defaultType?: 'paymentBy' | 'deposit';
  @Input() tabIndex?: number;
  @Input() skipRestrictions = false;
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;

  private destroy$ = new Subject<void>();
  constructor(
    http: _HttpClient,
    cdr: ChangeDetectorRef,
    private settingsService: SettingsService
  ) {
    super(http, cdr);
    this.valueField = '';
  }

  override ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.tabIndex) {
      const nzSelectElement =
        this.nzSelectComponent.originElement.nativeElement;
      const searchInput = nzSelectElement.querySelector('input');

      if (searchInput) {
        searchInput.setAttribute('tabindex', this.tabIndex?.toString() || '0');
      }
    }
  }
  getLabel(item: any) {
    if (item) {
      if (this.labelType === 'code') return item.code;
      else if (this.labelType === 'name') return item.name;
      return `${item.code} - ${item.name}`;
    }
    return '';
  }

  getUrl(searchValue: string): string {
    let url = `api/accountcodes/search?$top=50&$skip=0&$filter=IsActive eq true and (SpecialCode eq 'BAC' or SpecialCode eq 'BOAC' or SpecialCode eq 'CAC')`;

    if (this.defaultType) {
      url += `&type=${this.defaultType}`;
    }

    if (this.skipRestrictions) {
      url += `&skipRestrictions=true`;
    }

    if (searchValue && searchValue.trim()) {
      url += `&keyword=${encodeURIComponent(searchValue.trim())}`;
    } else {
      url += `&$orderby=code asc`;
    }

    return url;
  }

  // filter not working!
  // getUrl(searchValue: string): string {
  //   // Build filter step by step
  //   let filter = `(IsActive eq true and (SpecialCode eq 'BAC' or SpecialCode eq 'BOAC' or SpecialCode eq 'CAC'))`;

  //   if (searchValue && searchValue.trim()) {
  //     const searchStr = searchValue.replaceAll("'", "''");
  //     filter += ` and (contains(code, '${encodeURIComponent(searchStr)}') or contains(name,'${encodeURIComponent(searchStr)}'))`;
  //   }

  //   // Add type if available
  //   if (this.defaultType) {
  //     filter += ` and type eq '${this.defaultType}'`;
  //   }

  //   // Add fromCode and toCode range filter
  //   if (this.fromCode && this.toCode) {
  //     filter += ` and (code ge '${this.fromCode}' and code le '${this.toCode}')`;
  //   }

  //   return `api/accountcodes/search?$top=50&$skip=0&$orderby=code asc&$filter=${filter}`;
  // }
}
